import {
  startStream,
  stopStream,
  finishStream,
  isCurrentStream,
} from "@/utils/streamControllers";
import {
  streamList,
  StreamError,
  isRetryable,
  RETRY_LIMIT,
  retryDelay,
} from "@/utils/streamList";

export default {
  name: "format",
  namespaced: true,
  state: {
    formatList: [],
    loading: false,
    activeFormat: "",
  },
  mutations: {
    SET_FORMAT_LIST(state, payload) {
      state.formatList = payload;
    },
    APPEND_FORMAT_LIST(state, payload) {
      state.formatList.push(payload);
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_ACTIVE_FORMAT(state, payload) {
      state.activeFormat = payload;
    },
  },
  actions: {
    reset({ commit }) {
      stopStream("format");
      commit("SET_FORMAT_LIST", []);
      commit("SET_ACTIVE_FORMAT", "");
      commit("SET_LOADING", false);
    },
    resetLoading({ commit, state, dispatch }) {
      if (state.loading) {
        commit("SET_LOADING", false);
        dispatch("getFormats");
      }
    },
    async getFormats({ dispatch, commit }, { retries = 0 } = {}) {
      if (retries === 0) {
        await dispatch("reset");
      }
      const controller = startStream("format");
      commit("SET_FORMAT_LIST", []);
      commit("SET_LOADING", true);
      try {
        const { status, count } = await streamList(
          "generate/formats",
          {},
          {
            signal: controller.signal,
            onItem: (item) => {
              if (item.format) commit("APPEND_FORMAT_LIST", item);
            },
          }
        );
        if (status === 401) {
          dispatch("modals/openAuth", null, { root: true });
        } else if (status >= 500 || (status === 200 && count === 0)) {
          throw new StreamError("No formats were generated");
        }
      } catch (error) {
        if (!isCurrentStream("format", controller)) return;
        if (isRetryable(error) && retries < RETRY_LIMIT) {
          setTimeout(() => {
            if (isCurrentStream("format", controller)) {
              dispatch("getFormats", { retries: retries + 1 });
            }
          }, retryDelay(retries));
          return;
        }
        console.error(error);
      }
      if (isCurrentStream("format", controller)) {
        finishStream("format", controller);
        commit("SET_LOADING", false);
      }
    },
    addFormat({ commit }, format) {
      commit("APPEND_FORMAT_LIST", format);
    },
    selectFormat({ commit, state }, format) {
      if (state.activeFormat === format) {
        commit("SET_ACTIVE_FORMAT", "");
        return;
      }
      commit("SET_ACTIVE_FORMAT", format);
    },
  },
  getters: {},
  modules: {},
};
